(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["RecentPostsFeedEditorMode"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["RecentPostsFeedEditorMode"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__27762__, __WEBPACK_EXTERNAL_MODULE__88677__, __WEBPACK_EXTERNAL_MODULE__17607__) {
return 